export default __webpack_public_path__ + "static/media/designer-technology.022d917c.svg";